import axios from "./axios"


// 2) POST /v2.0/verifyOTP ⇒ 
//    { _id, error, errors, member: { firstName, lastName, … }, message, success, token }
/** Each error item is either a plain message string or a map from locale to message */
export type ErrorDetail = string | Record<string, string>;
export interface RawVerifyOtpPayload {
  _id: string;
  error: Record<string, unknown>;
  errors: ErrorDetail[];
  member: { firstName: string; lastName: string;_id:string; [k: string]: unknown };
  message: string;
  success: boolean;
  token: string;
}





interface ErrorResponse {
  response?: {
    data?: {
      errors?: Array<string | Record<string, string>>;
      errfor?: Record<string, string>;
    };
  };
  message?: string;
}

export const processToken = (localStorage: Storage, token: string | null, userName: string | null,id:string|null): void => {
  if (token && userName&&id) {
    localStorage.setItem('token', token);
    localStorage.setItem('userName', userName);
    localStorage.setItem('id', id);
  } else {
    localStorage.removeItem('token');
    localStorage.removeItem('userName');
    localStorage.removeItem('id');
  }
};

export const useToken = (localStorage: Storage): void => {
  const token = localStorage.getItem('token');
  if (token) {
    // setAuthToken(token);
  }
};

export function parseErrorMessage(response: unknown, locale: string = 'en-US'): string | null {
  if (!response) {
    return null;
  }

  // Handle string responses
  if (typeof response === "string") {
    return response;
    
  }

  // Handle Error objects
  if (response instanceof Error) {
    const msg = response.message;
    if (msg === "Request failed with status code 500") {
      return "Incorrect OTP, Please Try Again.";
    }
    return response.message;
  }

  // Handle complex error responses (Axios-style)
  if (typeof response === "object" && response !== null) {
    const err = response as ErrorResponse;

    // Check for nested response.data.errors
    if (err.response?.data?.errors?.length) {
      const firstError = err.response.data.errors[0];
      if (typeof firstError === "string") {
        return firstError;
      }
      return firstError[locale] || firstError["en-US"] || "An error has occurred";
    }

    // Check for errfor object
    if (err.response?.data?.errfor) {
      return Object.entries(err.response.data.errfor)
        .map(([key, value]) => `${key} ${value}`)
        .join(" ");
    }

    // Check for top-level message
    if (err.message) {
      return err.message;
    }
  }

  return "An error has occurred";
}

export const logout = (localStorage: Storage): void => {
  localStorage.removeItem('token');
  localStorage.removeItem('userName');
  window.location.href = '/login';
};

/**
 * Sends a POST to /v2.0/getOTP with { phone } and returns
 * the one‐time `secret` (to be used in verifyOTP).
 *
 * @param phone — national number (e.g. "15551234567") or E.164 ("+15551234567")
 * @returns      the `secret` string returned by the server
 * @throws      Error if the request fails
 */
export async function sendOTP(phone: string): Promise<string> {
  // 1. Normalize to E.164
  localStorage.setItem("phone", phone);
  const e164 = phone.startsWith('+') ? phone : `+${phone}`;

  // 2. Await the POST and pull out `secret`
  const resp = await axios.post<{ secret: string }>(
    `getOTP`,
    { phone: e164 },
    {
      headers: { 'Content-Type': 'application/json' },
      timeout: 10_000,
    }
  );
  return resp.data.secret;
}


/** Return type of verifyOTP (includes member name for user context). */
export interface VerifyOTPResult {
  token: string;
  userName: string;
  id: string;
  firstName?: string;
  lastName?: string;
  timezone?: string;
}

/**
 * Verifies an OTP using the `secret` from sendOTP.
 * Returns token, userName, id, and member firstName/lastName for the user context.
 */
export async function verifyOTP(
  secret: string | null,
  otp: string
): Promise<VerifyOTPResult> {
  if (!secret) {
    throw new Error('Missing secret—please request a new OTP');
  }
  const resp = await axios.post<RawVerifyOtpPayload>(
    `/verifyOTP`,
    { secret, otp },
    {
      headers: { 'Content-Type': 'application/json' },
      timeout: 10_000,
    }
  );
  const payload = resp.data;
  const token = payload.token;
  const { firstName, lastName, _id, timezone, timeZone } = payload.member as {
    firstName?: string;
    lastName?: string;
    _id: string;
    timezone?: string;
    timeZone?: string;
  };
  const userName = lastName ? `${firstName || ''} ${lastName}`.trim() : (firstName || '');
  const id = _id;
  const resolvedTimezone = timezone || timeZone;

  return { token, userName, id, firstName, lastName, timezone: resolvedTimezone };
}


export function getCommitmentScores(
  userIds:string[],
  badgeIds:string[],
  dateRange: any,
  timeInterval: any
) {
  const today = new Date();
  const priorDate = new Date().setDate(today.getDate() - 90);
  let startDate = new Date(priorDate).toISOString().slice(0, 10);
  let endDate = new Date().toISOString().slice(0, 10);
  if (timeInterval !== "current") {
    startDate = dateRange.start._i.toISOString().substring(0, 10);
    endDate = dateRange.end._i.toISOString().substring(0, 10);
  }
  const reqUrl = "/retroscores";
  return axios.post(reqUrl, {
    startDate: startDate,
    endDate: endDate,
    members: userIds,
    badge: badgeIds,
    timeInterval: timeInterval,
  });
}
export function getBadges() {
    return axios.get("/badge");
  }